module.exports = __webpack_public_path__ + "static/4e796a8f303fdcd930622ec2be921e5c.png";